import { removeLinksInSelection, getModalStyles, getLinkDataInSelection, isValidUrl, insertLink, } from 'wix-rich-content-common';
import { EditorState } from '@wix/draft-js';
import { Modals } from '../modals';
export function openLinkModal(helpers, isMobile, anchorTarget, relValue, t, theme, getEditorState, setEditorState) {
    var modalStyles = getModalStyles({ fullScreen: false });
    if (helpers && helpers.openModal) {
        var modalProps = {
            helpers: helpers,
            modalStyles: modalStyles,
            isMobile: isMobile,
            getEditorState: getEditorState,
            setEditorState: setEditorState,
            t: t,
            theme: theme,
            anchorTarget: anchorTarget,
            relValue: relValue,
            modalName: Modals.TEXT_LINK,
            hidePopup: helpers.closeModal,
            componentData: {
                title: 'Add Link',
                description: 'Set link URL',
                placeholder: 'https://www.deviantart.com/',
                showRemoveLink: true,
                validateUrl: function (url) { return !url || isValidUrl(url); },
                getUrl: function () {
                    var linkData = getLinkDataInSelection(getEditorState());
                    return linkData ? linkData.url : '';
                },
                updateUrl: function (url) {
                    if (url) {
                        var newEditorState = insertLink(getEditorState(), {
                            url: url,
                            targetBlank: '_blank',
                            nofollow: 'nofollow',
                            anchorTarget: anchorTarget,
                            relValue: relValue,
                        });
                        setEditorState(newEditorState);
                    }
                    else {
                        var editorState = getEditorState();
                        var selection = editorState.getSelection();
                        var newEditorState = removeLinksInSelection(editorState);
                        setEditorState(EditorState.forceSelection(newEditorState, selection));
                    }
                },
            },
        };
        helpers.openModal(modalProps);
    }
}
//# sourceMappingURL=helpers.js.map